import { supabase } from '../supabase/config';
import { updateEvent, getAllEvents, deleteEvent } from '../supabase/events';

// Check if any fields have been modified
export const checkForChanges = () => {
  if (!window.originalEventData) return false;
  
  const panel = document.getElementById('eventDetailsPanel');
  if (!panel) return false;
  
  // Check title
  const titleInput = document.getElementById('edit-title');
  if (titleInput && titleInput.value.trim() !== window.originalEventData.title) {
    return true;
  }
  
  // Check description
  const descInput = document.getElementById('edit-description');
  if (descInput && descInput.value.trim() !== window.originalEventData.description) {
    return true;
  }
  
  // Check start date/time
  const startDateInput = document.getElementById('edit-start-date');
  const startTimeInput = document.getElementById('edit-start-time');
  if (startDateInput && startTimeInput && startDateInput.value && startTimeInput.value) {
    const newStartDateTime = `${startDateInput.value}T${startTimeInput.value}`;
    if (newStartDateTime !== window.originalEventData.startDateTime) {
      return true;
    }
  }
  
  // Check end date/time
  const endDateInput = document.getElementById('edit-end-date');
  const endTimeInput = document.getElementById('edit-end-time');
  if (endDateInput && endTimeInput && endDateInput.value && endTimeInput.value) {
    const newEndDateTime = `${endDateInput.value}T${endTimeInput.value}`;
    if (newEndDateTime !== window.originalEventData.endDateTime) {
      return true;
    }
  }

  // Check people limit
  if (panel.dataset.tempPeopleLimit !== undefined) {
    const newLimit = panel.dataset.tempPeopleLimit === 'null' ? null : parseInt(panel.dataset.tempPeopleLimit);
    const originalLimit = window.originalEventData.peopleLimit;
    if (newLimit !== originalLimit) {
      return true;
    }
  }

  // Check label
  const labelInput = document.getElementById('edit-label');
  if (labelInput && labelInput.value.trim() !== panel.dataset.customLabel) {
    return true;
  }

// Check require approval
  const requireApproveCheckbox = document.getElementById('edit-require-approve');
  if (requireApproveCheckbox) {
    const originalRequireApprove = window.originalEventData.requireApprove === true || window.originalEventData.requireApprove === 'true';
    if (requireApproveCheckbox.checked !== originalRequireApprove) {
      return true;
    }
  }
  
// Check gender preference
  const genderSection = document.getElementById('edit-gender-preference-section');
  if (genderSection) {
    const currentGenders = [];
    ['man', 'woman', 'different'].forEach(g => {
      const btn = document.getElementById(`edit-gender-${g}`);
      if (btn && btn.dataset.selected === 'true') {
        currentGenders.push(g);
      }
    });
    
    // If no genders selected, don't count as a valid change
    if (currentGenders.length === 0) {
      // Store flag that gender is invalid
      window.genderPreferenceInvalid = true;
      return false;
    }
    window.genderPreferenceInvalid = false;
    
    const originalGenders = window.originalEventData.genderPreference || ['man', 'woman', 'different'];
    
    // Compare arrays
    const sameLength = currentGenders.length === originalGenders.length;
    const sameContent = currentGenders.every(g => originalGenders.includes(g));
    
if (!sameLength || !sameContent) {
      return true;
    }
  }

  // Check age limit
  const ageLimitSection = document.getElementById('edit-age-limit-section');
  if (ageLimitSection) {
    const origMin = window.originalEventData.ageMin || 18;
    const origMax = window.originalEventData.ageMax || 99;
    if (window.currentAgeMin !== origMin || window.currentAgeMax !== origMax) {
      return true;
    }
  }
  
// Check category
  const categorySection = document.getElementById('edit-category-section');
  if (categorySection && window.currentEventCategories) {
    const originalCategories = window.originalEventData.category || ['entertainment'];
    const currentCategories = window.currentEventCategories;
    const sameCatLength = currentCategories.length === originalCategories.length;
    const sameCatContent = currentCategories.every(c => originalCategories.includes(c));
    if (!sameCatLength || !sameCatContent) {
      return true;
    }
  }

  // Check image change
  if (window._editImageState && window._editImageState !== 'original') {
    return true;
  }
  
  return false;
};

// Update save button state based on changes
export const updateSaveButtonState = () => {
  const saveButton = document.querySelector('button[onclick*="saveEventChanges"]');
  if (!saveButton) return;
  
  const hasChanges = window.checkForChanges();
  
// Check if gender preference is invalid (no genders selected)
  const genderSection = document.getElementById('edit-gender-preference-section');
  let genderInvalid = false;
  if (genderSection) {
    const selectedCount = ['man', 'woman', 'different'].filter(g => {
      const btn = document.getElementById(`edit-gender-${g}`);
      return btn && btn.dataset.selected === 'true';
    }).length;
    genderInvalid = selectedCount === 0;
  }

// Check if start date/time is after end date/time
  // Fall back to original values when one side isn't being edited
  let datesInvalid = false;
  const startDateInput = document.getElementById('edit-start-date');
  const startTimeInput = document.getElementById('edit-start-time');
  const endDateInput = document.getElementById('edit-end-date');
  const endTimeInput = document.getElementById('edit-end-time');
  const panel = document.getElementById('eventDetailsPanel');
const originalStart = window.originalEventData?.startDateTime || panel?.dataset?.startDateTime;
  const originalEnd = window.originalEventData?.endDateTime || panel?.dataset?.endDateTime;
  // Strip timezone to ensure both sides are compared as local time strings
  const stripTZ = (dt) => dt ? dt.substring(0, 16) : null; // "YYYY-MM-DDTHH:MM"
  const startVal = (startDateInput?.value && startTimeInput?.value)
    ? `${startDateInput.value}T${startTimeInput.value}`
    : stripTZ(originalStart);
  const endVal = (endDateInput?.value && endTimeInput?.value)
    ? `${endDateInput.value}T${endTimeInput.value}`
    : stripTZ(originalEnd);
  if (startVal && endVal) {
    if (startVal >= endVal) datesInvalid = true;
  }

  if (hasChanges && !genderInvalid && !datesInvalid) {
    // Enable button - green and clickable
    saveButton.style.opacity = '1';
    saveButton.style.cursor = 'pointer';
    saveButton.disabled = false;
    saveButton.style.filter = 'none';
  } else {
    // Disable button - greyed out
    saveButton.style.opacity = '0.4';
    saveButton.style.cursor = 'not-allowed';
    saveButton.disabled = true;
    saveButton.style.filter = 'grayscale(1)';
  }
};

// Enable edit mode
export const enableEditMode = (eventId) => {
  // Store original data
  const panel = document.getElementById('eventDetailsPanel');
  if (!panel) return;
  
// Re-check hasStarted with current time using master status calculator
  const startDateTime = panel.dataset.startDateTime;
  const endDateTime = panel.dataset.endDateTime;
  if (startDateTime && window.calculateEventStatus) {
    const status = window.calculateEventStatus(startDateTime, endDateTime);
    panel.dataset.hasStarted = status.hasStarted.toString();
    console.log('🔄 Re-checked hasStarted:', status.hasStarted, 'status:', status.statusText);
  }
  
  // Get all the current values and store them
window.originalEventData = {
    title: panel.querySelector('[data-event-title]')?.textContent.trim(),
    description: panel.dataset.originalDescription,
    startDateTime: panel.dataset.startDateTime,
    endDateTime: panel.dataset.endDateTime,
    requireApprove: panel.dataset.requireApprove === 'true',
    genderPreference: panel.dataset.genderPreference ? JSON.parse(panel.dataset.genderPreference) : ['man', 'woman', 'different'],
category: panel.dataset.category ? JSON.parse(panel.dataset.category) : ['entertainment'],
    ageMin: parseInt(panel.dataset.ageMin) || 18,
    ageMax: parseInt(panel.dataset.ageMax) || 99
  };
  
  // Track if any changes have been made
  window.hasUnsavedChanges = false;
  
  // Make fields editable
  window.makeFieldsEditable();
  
  // Update action buttons to Save/Cancel (sticky at bottom)
  const actionButtons = document.getElementById('actionButtons');
  if (actionButtons) {
      // Show the edit people limit icon
  const editPeopleLimitIcon = document.getElementById(`editPeopleLimitIcon_${eventId}`);
  if (editPeopleLimitIcon) {
    editPeopleLimitIcon.style.display = 'inline';
  }
    actionButtons.style.cssText = `
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 16px 24px;
      background: white;
      border-top: 1px solid #e5e7eb;
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    `;
    
    actionButtons.innerHTML = `
      <div style="
        display: flex;
        gap: 12px;
        justify-content: center;
      ">
<!-- Save Button (green checkmark) -->
<button
  onclick="if (!this.disabled) saveEventChanges('${eventId}')"
  style="
    width: 50px;
    height: 50px;
    padding: 0;
    background: #f8f9fa;
    color: #22c55e;
    border: 2px solid #22c55e;
    border-radius: 50%;
    cursor: not-allowed;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(0, 0, 0, 0.4) 2px 2px 6px;
    opacity: 0.4;
    filter: grayscale(1);
  "
  disabled
  onmouseover="if (!this.disabled) this.style.background='#e6f7ed';"
  onmouseout="if (!this.disabled) this.style.background='#f8f9fa';"
  title="Save changes"
>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
</button>
        
        <!-- Cancel Button (grey X) -->
        <button
          onclick="cancelEditMode()"
          style="
            width: 50px;
            height: 50px;
            padding: 0;
            background: #f8f9fa;
            color: #838383;
            border: 2px solid #838383;
            border-radius: 50%;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: rgba(0, 0, 0, 0.4) 2px 2px 6px;
          "
          onmouseover="this.style.background='#dddddd';"
          onmouseout="this.style.background='#f8f9fa';"
          title="Cancel editing"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    `;
  }
    // Debug: Check if back button still exists after edit mode
  const backButtonAfter = panel.querySelector('button[onclick*="showEventsListPanel"]');
};

// Make fields editable with pencil icons
export const makeFieldsEditable = () => {
  const panel = document.getElementById('eventDetailsPanel');
  if (!panel) return;
  
  // Get event data from panel
  const eventId = panel.dataset.eventId;
  const isCustom = panel.dataset.isCustom === 'true';
  const hasStarted = panel.dataset.hasStarted === 'true';
  
  // Track which fields are currently being edited
  const editingFields = new Set();
  
// 1. Title - Add pencil icon (gentle editing)
const titleElement = panel.querySelector('[data-event-title]');
const titleContainer = titleElement?.parentElement;

if (titleElement && titleContainer && !titleContainer.dataset.editIconAdded) {
  titleContainer.dataset.editIconAdded = 'true';
  
  const pencilIcon = document.createElement('button');
  pencilIcon.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4285f4" stroke-width="2">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
  `;
  pencilIcon.style.cssText = `
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    transition: transform 0.2s, opacity 0.2s;
    opacity: 1;
  `;
  pencilIcon.onmouseover = () => {
    pencilIcon.style.transform = 'translateY(-50%) scale(1.1)';
  };
  pencilIcon.onmouseout = () => {
    pencilIcon.style.transform = 'translateY(-50%) scale(1)';
  };
  
  pencilIcon.onclick = (e) => {
    e.stopPropagation();
    
    const currentValue = titleElement.textContent.trim();
    
    // Store original HTML for restoration
    const originalHTML = titleElement.innerHTML;
    
    // Replace title with inline input
    titleElement.innerHTML = `
      <input 
        type="text"
        id="edit-title"
        value="${currentValue.replace(/"/g, '&quot;')}"
        maxlength="60"
        style="
          width: 100%;
          max-width: 280px;
          padding: 6px 10px;
          border: 2px solid #4285f4;
          border-radius: 6px;
          font-size: 18px;
          font-weight: 600;
          color: #202124;
          font-family: inherit;
          box-sizing: border-box;
        "
      />
    `;
    
const input = document.getElementById('edit-title');
if (input) {
  input.focus();
  input.select();
  
  // Add change listener
  input.addEventListener('input', () => {
    window.updateSaveButtonState();
  });
  
  // Store original for cancel
  input.dataset.original = currentValue;
}
    
    // Hide pencil while editing
    pencilIcon.style.display = 'none';
  };
  
  titleContainer.style.position = 'relative';
  titleContainer.appendChild(pencilIcon);
}
  
// 3. Start Date/Time - Add pencil icon (only if not started)
if (!hasStarted) {
  const startRow = panel.querySelector('[data-start-row]');
  if (startRow && !startRow.dataset.editIconAdded) {
    startRow.dataset.editIconAdded = 'true';
    
    const startValueP = startRow.querySelector('[data-start-value]');
    if (startValueP) {
      const pencilIcon = document.createElement('button');
      pencilIcon.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4285f4" stroke-width="2">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
      `;
      pencilIcon.style.cssText = `
        position: absolute;
        right: 4px;
        top: 50%;
        transform: translateY(-50%);
        background: none;
        border: none;
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;
        transition: transform 0.2s;
      `;
      pencilIcon.onmouseover = () => pencilIcon.style.transform = 'translateY(-50%) scale(1.1)';
      pencilIcon.onmouseout = () => pencilIcon.style.transform = 'translateY(-50%) scale(1)';
      
      pencilIcon.onclick = (e) => {
        e.stopPropagation();
        
        const currentStartDateTime = panel.dataset.startDateTime;
        
        const dateTimeParts = currentStartDateTime.split('T');
        const dateValue = dateTimeParts[0]; 
        
        const timeParts = dateTimeParts[1].split(':');
        const hours = timeParts[0];
        const minutes = String(Math.floor(parseInt(timeParts[1]) / 5) * 5).padStart(2, '0');
        const timeValue = `${hours}:${minutes}`;
        
        const now = new Date();
        const minDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
        
        const maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 1);
        const maxDateStr = `${maxDate.getFullYear()}-${String(maxDate.getMonth() + 1).padStart(2, '0')}-${String(maxDate.getDate()).padStart(2, '0')}`;
        
        const timeOptions = [];
        for (let hour = 0; hour < 24; hour++) {
          for (let minute = 0; minute < 60; minute += 5) {
            if (hour === 0 && minute === 0) continue;
            const timeString = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
            timeOptions.push(`<option value="${timeString}">${timeString}</option>`);
          }
        }
        
        startValueP.innerHTML = `
          <div style="display: flex; gap: 8px; flex-direction: column;">
            <input 
              type="date"
              id="edit-start-date"
              value="${dateValue}"
              min="${minDate}"
              max="${maxDateStr}"
              onchange="window.updateEditStartTimeOptions(); window.updateEditEndDateMin(); window.updateSaveButtonState();"
              style="
                width: 100%;
                padding: 6px 8px;
                border: 2px solid #4285f4;
                border-radius: 6px;
                font-size: 12px;
                box-sizing: border-box;
                cursor: pointer;
              "
            />
            <select 
              id="edit-start-time"
              onchange="window.updateEditEndTimeMin(); window.updateSaveButtonState();"
              onfocus="window.updateEditStartTimeOptions()"
              style="
                width: 100%;
                padding: 6px 8px;
                border: 2px solid #4285f4;
                border-radius: 6px;
                font-size: 12px;
                box-sizing: border-box;
                cursor: pointer;
                background: white;
              "
            >
              <option value="">Select time</option>
              ${timeOptions.join('')}
            </select>
          </div>
        `;
        
        const timeSelect = document.getElementById('edit-start-time');
        if (timeSelect) {
          timeSelect.value = timeValue;
        }
        
        window.updateEditStartTimeOptions();
        pencilIcon.style.display = 'none';
      };
      
      startRow.appendChild(pencilIcon);
    }
  }
}
  
// 4. End Date/Time - Add pencil icon (always editable, unless finished)
const endRow = panel.querySelector('[data-end-row]');
if (endRow && !endRow.dataset.editIconAdded) {
  endRow.dataset.editIconAdded = 'true';
  
  const endValueP = endRow.querySelector('[data-end-value]');
  if (endValueP) {
    const pencilIcon = document.createElement('button');
    pencilIcon.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4285f4" stroke-width="2">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
      </svg>
    `;
    pencilIcon.style.cssText = `
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      transition: transform 0.2s;
    `;
    pencilIcon.onmouseover = () => pencilIcon.style.transform = 'translateY(-50%) scale(1.1)';
    pencilIcon.onmouseout = () => pencilIcon.style.transform = 'translateY(-50%) scale(1)';
    
    pencilIcon.onclick = (e) => {
      e.stopPropagation();
      
      const currentEndDateTime = panel.dataset.endDateTime;
      
      const dateTimeParts = currentEndDateTime.split('T');
      const dateValue = dateTimeParts[0];
      
      const timeParts = dateTimeParts[1].split(':');
      const hours = timeParts[0];
      const minutes = String(Math.floor(parseInt(timeParts[1]) / 5) * 5).padStart(2, '0');
      const timeValue = `${hours}:${minutes}`;
      
      const startDateTime = panel.dataset.startDateTime;
      const startDate = new Date(startDateTime);
      
      const now = new Date();
      const hasStarted = now >= startDate;
      
      let minDate, constraintTime, constraintDate;
      
      if (hasStarted) {
        const nowYear = now.getFullYear();
        const nowMonth = String(now.getMonth() + 1).padStart(2, '0');
        const nowDay = String(now.getDate()).padStart(2, '0');
        minDate = `${nowYear}-${nowMonth}-${nowDay}`;
        constraintDate = minDate;
        const nowHours = String(now.getHours()).padStart(2, '0');
        const nowMinutes = String(Math.ceil(now.getMinutes() / 5) * 5).padStart(2, '0');
        constraintTime = `${nowHours}:${nowMinutes}`;
      } else {
        minDate = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;
        constraintDate = minDate;
        const startHours = String(startDate.getHours()).padStart(2, '0');
        const startMinutes = String(Math.floor(startDate.getMinutes() / 5) * 5).padStart(2, '0');
        constraintTime = `${startHours}:${startMinutes}`;
      }
      
      const maxDate = new Date(startDate);
      maxDate.setDate(maxDate.getDate() + 7);
      const maxDateStr = `${maxDate.getFullYear()}-${String(maxDate.getMonth() + 1).padStart(2, '0')}-${String(maxDate.getDate()).padStart(2, '0')}`;
      
      const startDateInput = document.getElementById('edit-start-date');
      const startTimeInput = document.getElementById('edit-start-time');
      
      if (!hasStarted && startDateInput && startTimeInput && startDateInput.value && startTimeInput.value) {
        constraintDate = startDateInput.value;
        constraintTime = startTimeInput.value;
        minDate = constraintDate;
      }
      
      const timeOptions = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 5) {
          if (hour === 0 && minute === 0) continue;
          const timeString = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
          let disabled = false;
          if (dateValue === constraintDate && constraintTime) {
            const [cH, cM] = constraintTime.split(':').map(Number);
            disabled = (hour * 60 + minute) <= (cH * 60 + cM);
          }
          timeOptions.push(`<option value="${timeString}" ${disabled ? 'disabled' : ''}>${timeString}</option>`);
        }
      }
      
      endValueP.innerHTML = `
        <div style="display: flex; gap: 8px; flex-direction: column;">
          <input 
            type="date"
            id="edit-end-date"
            value="${dateValue}"
            min="${minDate}"
            max="${maxDateStr}"
            data-has-started="${hasStarted}"
            data-constraint-date="${constraintDate}"
            data-constraint-time="${constraintTime}"
            onchange="window.updateEditEndTimeMin(); window.updateSaveButtonState();"
            style="
              width: 100%;
              padding: 6px 8px;
              border: 2px solid #4285f4;
              border-radius: 6px;
              font-size: 12px;
              box-sizing: border-box;
              cursor: pointer;
            "
          />
          <select 
            id="edit-end-time"
            onfocus="window.updateEditEndTimeMin()"
            onchange="window.validateEditEndDateTime(); window.updateSaveButtonState();"
            style="
              width: 100%;
              padding: 6px 8px;
              border: 2px solid #4285f4;
              border-radius: 6px;
              font-size: 12px;
              box-sizing: border-box;
              cursor: pointer;
              background: white;
            "
          >
            <option value="">Select time</option>
            ${timeOptions.join('')}
          </select>
        </div>
      `;
      
      const timeSelect = document.getElementById('edit-end-time');
      if (timeSelect) {
        const option = Array.from(timeSelect.options).find(opt => opt.value === timeValue);
        if (option && !option.disabled) {
          timeSelect.value = timeValue;
        }
      }
      
      window.updateEditEndTimeMin();
      pencilIcon.style.display = 'none';
    };
    
    endRow.appendChild(pencilIcon);
  }
}
  
  // 5. Change Place Image - custom pins only
  const isCustomPin = panel.dataset.isCustom === 'true';
  const locateButton = panel.querySelector('button[onclick*="flyTo"]');
if (isCustomPin && locateButton && locateButton.parentElement && !document.getElementById('edit-image-section')) {
    const existingPhotoUrl = panel.dataset.placePhotoUrl || '';
    const hasExistingImage = !!existingPhotoUrl;

    const imageUploadHtml = `
      <div id="edit-image-section" style="margin: 16px 0;">
        <label style="display: block; font-size: 12px; font-weight: 600; color: #5f6368; margin-bottom: 8px; text-transform: uppercase;">
          Event Image (optional)
        </label>

        ${hasExistingImage ? `
        <!-- Existing image preview -->
<div id="edit-image-preview" style="position: relative; margin-bottom: 10px; display: flex; flex-direction: column; align-items: center; gap: 6px;">
          <div style="position: relative; width: 100px; height: 100px;">
            <div style="width: 100px; height: 100px; border-radius: 50%; overflow: hidden; border: 3px solid #4285f4; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
              <img id="edit-image-preview-img" src="${existingPhotoUrl}" alt="Event image" style="width: 100%; height: 100%; object-fit: cover; display: block;" />
            </div>
            <button
              onclick="window.clearEditEventImage()"
              style="position: absolute; top: -2px; right: -2px; background: #ea4335; border: 2px solid white; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: white; font-size: 12px; line-height: 1;"
              title="Remove image"
            >✕</button>
          </div>
          <p style="margin: 0; font-size: 11px; color: #9e9e9e;">Preview on marker</p>
        </div>
        ` : `
<div id="edit-image-preview" style="display: none; position: relative; margin-bottom: 10px; flex-direction: column; align-items: center; gap: 6px;">
          <div style="position: relative; width: 100px; height: 100px;">
            <div style="width: 100px; height: 100px; border-radius: 50%; overflow: hidden; border: 3px solid #4285f4; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
              <img id="edit-image-preview-img" src="" alt="Event image" style="width: 100%; height: 100%; object-fit: cover; display: block;" />
            </div>
            <button
              onclick="window.clearEditEventImage()"
              style="position: absolute; top: -2px; right: -2px; background: #ea4335; border: 2px solid white; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: white; font-size: 12px; line-height: 1;"
              title="Remove image"
            >✕</button>
          </div>
          <p style="margin: 0; font-size: 11px; color: #9e9e9e;">Preview on marker</p>
        </div>
        `}

        <div style="
          border: 2px dashed #dadce0;
          border-radius: 8px;
          padding: 16px;
          text-align: center;
          background: #f8f9fa;
          cursor: pointer;
          transition: all 0.2s;
        "
        onmouseover="this.style.borderColor='#4285f4'; this.style.background='#f1f5f9'"
        onmouseout="this.style.borderColor='#dadce0'; this.style.background='#f8f9fa'"
        onclick="window._triggerImagePicker('edit-place-image', (e) => window.handleEditEventImageUpload(e), { maxSize: 600, quality: 90 })"
        >
          <input 
            type="file"
            id="edit-place-image"
            accept="image/*"
            style="display: none;"
            onchange="window.handleEditEventImageUpload(this)"
          />
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#5f6368" stroke-width="2" style="margin: 0 auto 6px;">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <polyline points="21 15 16 10 5 21"></polyline>
          </svg>
          <p style="margin: 0; font-size: 13px; color: #5f6368; font-weight: 500;">${hasExistingImage ? 'Replace Image' : 'Choose Image'}</p>
        </div>
      </div>
    `;
    
    locateButton.parentElement.insertAdjacentHTML('afterend', imageUploadHtml);

    // Store original photo url so we can detect changes
    window._editOriginalPhotoUrl = existingPhotoUrl;
    // Track current image state: 'original' | 'removed' | 'replaced'
    window._editImageState = 'original';

    // Handler: new file selected — accepts either an <input> element or
    // an event-shaped object ({ target: { files: [file] } }) for native picker
    window.handleEditEventImageUpload = (inputOrEvent) => {
      const filesSource = inputOrEvent?.files || inputOrEvent?.target?.files;
      const file = filesSource && filesSource[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => {
          const MAX_SIZE = 600;
          let { width, height } = img;
          if (width > MAX_SIZE || height > MAX_SIZE) {
            if (width > height) { height = Math.round(height * MAX_SIZE / width); width = MAX_SIZE; }
            else { width = Math.round(width * MAX_SIZE / height); height = MAX_SIZE; }
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, width, height);
          const compressed = canvas.toDataURL('image/jpeg', 0.9);

          const previewDiv = document.getElementById('edit-image-preview');
          const previewImg = document.getElementById('edit-image-preview-img');
          if (previewDiv && previewImg) {
            previewImg.src = compressed;
            previewDiv.style.display = 'flex';
          }
          window._editImageState = 'replaced';
          window._editNewImageBase64 = compressed;
          window.updateSaveButtonState();
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    };

    // Handler: remove image
    window.clearEditEventImage = () => {
      const previewDiv = document.getElementById('edit-image-preview');
      const fileInput = document.getElementById('edit-place-image');
      if (previewDiv) previewDiv.style.display = 'none';
      if (fileInput) fileInput.value = '';
      window._editImageState = 'removed';
      window._editNewImageBase64 = null;
      window.updateSaveButtonState();
    };
  }
  
  // 6. Label Input for Custom Events
  if (isCustom) {
    const imageSection = document.getElementById('edit-image-section');
    if (imageSection && !document.getElementById('edit-label-section')) {
      const currentLabel = panel.dataset.customLabel || '';
      const labelInputHtml = `
        <div id="edit-label-section" style="margin: 16px 0; position: relative;">
          <label style="display: block; font-size: 12px; font-weight: 600; color: #5f6368; margin-bottom: 8px; text-transform: uppercase;">
            Label <span style="color: #000; margin-left: 2px;">*</span> <span style="color: #5f6368; font-weight: 400;">(visible on event marker)</span>
          </label>
          <div style="position: relative;">
            <div 
              id="label-display"
              style="
                padding: 12px;
                border: 2px solid #dadce0;
                border-radius: 8px;
                font-size: 14px;
                color: #202124;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
              onclick="
                document.getElementById('label-display').style.display = 'none';
                document.getElementById('label-input-wrapper').style.display = 'block';
                document.getElementById('edit-label').focus();
              "
            >
              <span>${currentLabel || 'Click to edit label'}</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4285f4" stroke-width="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
            </div>
            <div id="label-input-wrapper" style="display: none;">
              <input
                type="text"
                id="edit-label"
                value="${currentLabel.replace(/"/g, '&quot;')}"
                maxlength="37"
                placeholder="e.g., Beach Volleyball, Park Meetup"
                oninput="if(window.updateSaveButtonState) window.updateSaveButtonState()"
                style="
                  width: 100%;
                  padding: 12px;
                  border: 2px solid #4285f4;
                  border-radius: 8px;
                  font-size: 14px;
                  box-sizing: border-box;
                "
              />
            </div>
          </div>
        </div>
      `;
      
      imageSection.insertAdjacentHTML('afterend', labelInputHtml);
    }
  }

  let descContainer = panel.querySelector('[data-description-container]');

  if (!descContainer) {
    const headers = panel.querySelectorAll('h4');
    for (const header of headers) {
      console.log('Header text:', header.textContent.trim());
      if (header.textContent.trim() === 'DESCRIPTION') {
        descContainer = header.parentElement;
        break;
      }
    }
  }
  
  if (!descContainer) {
    return;
  }
  
  const existingIcon = descContainer.querySelector('[data-desc-edit-icon]');
  if (existingIcon) {
    existingIcon.remove();
  }
  
let descContent = descContainer.querySelector('p') || 
                  descContainer.querySelector('pre') ||  // ← ADD THIS
                  descContainer.querySelector('[data-event-description]') ||
                  descContainer.querySelector('div');

  if (descContent && !document.getElementById('edit-description')) {
    const descEditIcon = document.createElement('span');
    descEditIcon.setAttribute('data-desc-edit-icon', 'true');
    descEditIcon.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4285f4" stroke-width="2">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
      </svg>
    `;
    descEditIcon.style.cssText = `
      cursor: pointer;
      margin-left: 8px;
      display: inline-block;
      vertical-align: middle;
    `;
    
    descEditIcon.onmouseover = () => descEditIcon.querySelector('svg').style.scale = '1.1';
    descEditIcon.onmouseout = () => descEditIcon.querySelector('svg').style.scale = '1';
    
descEditIcon.onclick = (e) => {
e.stopPropagation();
  
  const originalText = panel.dataset.originalDescription || 
                       descContent.textContent.replace('Read less', '').replace('...Read more', '').trim();
  
  const textarea = document.createElement('textarea');
  textarea.id = 'edit-description';
  textarea.value = originalText;
  textarea.maxLength = 1500;
  textarea.style.cssText = `
    width: 100%;
    min-height: 120px;
    padding: 12px;
    border: 2px solid #4285f4;
    border-radius: 8px;
    font-size: 14px;
    font-family: inherit;
    resize: vertical;
    box-sizing: border-box;
  `;
  
  const expandButton = descContainer.querySelector('[data-expand-button]');
  if (expandButton) expandButton.style.display = 'none';
  
  descContent.style.display = 'none';
  descEditIcon.style.display = 'none';
  descContainer.insertBefore(textarea, descContent);
  
  textarea.focus();
  textarea.setSelectionRange(textarea.value.length, textarea.value.length);

  // Add change listener
textarea.addEventListener('input', () => {
  window.updateSaveButtonState();
});
};
    
    // Find the DESCRIPTION label/header
    console.log('🔍 Looking for DESCRIPTION label...');
    
    // Search the entire panel for the text "DESCRIPTION"
    const allElements = panel.querySelectorAll('*');
    let descriptionLabel = null;
    
    for (const element of allElements) {
      // Check if this element contains ONLY "DESCRIPTION" text (or very close to it)
      const text = element.textContent.trim();
      const ownText = Array.from(element.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent.trim())
        .join('');
      
      if (ownText === 'DESCRIPTION' || text === 'DESCRIPTION') {
        descriptionLabel = element;
        break;
      }
    }
    
    if (descriptionLabel) {
      descriptionLabel.style.display = 'inline-block';
      descriptionLabel.appendChild(descEditIcon);
    } else {
      // Fallback: add to container with absolute positioning (matching other icons)
      descEditIcon.style.cssText = `
        position: absolute;
        top: 4px;
        right: 4px;
        background: none;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        transition: transform 0.2s, opacity 0.2s;
        opacity: 1;
        z-index: 10;
      `;
      
      // Add hover effects matching other pencil icons
      descEditIcon.onmouseover = () => {
        descEditIcon.style.transform = 'scale(1.1)';
      };
      descEditIcon.onmouseout = () => {
        descEditIcon.style.transform = 'scale(1)';
      };
      
      descContainer.style.position = 'relative';
      descContainer.appendChild(descEditIcon);
    }
  }
// Add pencil icon for people limit (organizer only)
  const participantsHeader = Array.from(panel.querySelectorAll('h4')).find(h => h.textContent.includes('PARTICIPANTS'));
  if (participantsHeader && !participantsHeader.dataset.limitEditIconAdded) {
    participantsHeader.dataset.limitEditIconAdded = 'true';
    
    const pencilIcon = document.createElement('button');
    pencilIcon.id = `editPeopleLimitIcon_${panel.dataset.eventId}`;
    pencilIcon.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4285f4" stroke-width="2">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
      </svg>
    `;
    pencilIcon.style.cssText = `
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      transition: transform 0.2s, opacity 0.2s;
      opacity: 1;
    `;
    pencilIcon.onmouseover = () => {
      pencilIcon.style.transform = 'translateY(-50%) scale(1.1)';
    };
    pencilIcon.onmouseout = () => {
      pencilIcon.style.transform = 'translateY(-50%) scale(1)';
    };
    
    pencilIcon.onclick = async (e) => {
      e.stopPropagation();
      
      // Fetch current event data
      const supabaseClient = window.supabase || supabase;
      const { data: eventData, error } = await supabaseClient
        .from('events')
        .select('participants, people_limit')
        .eq('event_id', panel.dataset.eventId)
        .single();
      
      if (!error && eventData) {
        const currentParticipants = eventData.participants?.length || 1;
        const currentLimit = eventData.people_limit;
        window.showEditPeopleLimitModal(panel.dataset.eventId, currentParticipants, currentLimit);
      }
    };
    
    participantsHeader.style.position = 'relative';
    participantsHeader.appendChild(pencilIcon);
  }

// Add "Require Approval" checkbox in edit mode (below PARTICIPANTS section)
if (participantsHeader && !document.getElementById('edit-require-approval-section')) {
  const currentRequireApprove = panel.dataset.requireApprove === 'true';
  
  const requireApprovalHtml = `
    <div id="edit-require-approval-section" style="margin-top: 12px;">
      <div style="
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #5f6368;
      ">
        <input 
          type="checkbox"
          id="edit-require-approve"
          ${currentRequireApprove ? 'checked' : ''}
          onchange="window.updateSaveButtonState();"
          style="
            width: 18px;
            height: 18px;
            cursor: pointer;
            margin: 0;
            accent-color: #008fa1;
          "
        />
        <span style="user-select: none; cursor: default;">Require Approve</span>
        <button
          type="button"
          onclick="window.showRequireApproveInfo(event)"
          style="
            background: none;
            border: none;
            cursor: pointer;
            padding: 0;
            margin-left: 4px;
            display: flex;
            align-items: center;
          "
          title="Learn more about Require Approve"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5f6368" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4"></path>
            <circle cx="12" cy="8" r="0.5" fill="#5f6368"></circle>
          </svg>
        </button>
      </div>
    </div>
  `;
  
  // Find the entire participants section (the outer div with margin: 20px 0)
  const participantsSection = participantsHeader.closest('div[style*="margin: 20px 0"]') || 
                               participantsHeader.closest('div[style*="margin:20px 0"]');
  
if (participantsSection) {
    // Insert after the entire participants section
    participantsSection.insertAdjacentHTML('afterend', requireApprovalHtml);
  }
  
  // Initialize window.tempRequireApprove
  window.tempRequireApprove = currentRequireApprove;
}

// Add "Open for" gender preference in edit mode (below Require Approval section)
const requireApprovalSection = document.getElementById('edit-require-approval-section');
if (requireApprovalSection && !document.getElementById('edit-gender-preference-section')) {
  const currentGenderPref = panel.dataset.genderPreference ? 
    JSON.parse(panel.dataset.genderPreference) : 
    ['man', 'woman', 'different'];
  
  // Initialize the global variable with current values
  window.currentEventGenderPreference = [...currentGenderPref];
  
  const hasMan = currentGenderPref.includes('man');
  const hasWoman = currentGenderPref.includes('woman');
  const hasDifferent = currentGenderPref.includes('different');
  
  const genderPrefHtml = `
    <div id="edit-gender-preference-section" style="margin-top: 16px;">
      <label style="display: block; font-size: 12px; font-weight: 600; color: #5f6368; margin-bottom: 8px; text-transform: uppercase;">
        Open for
      </label>
      <div style="display: flex; gap: 8px; flex-wrap: wrap;">
        <button
          type="button"
          id="edit-gender-man"
          data-gender="man"
          data-selected="${hasMan}"
          onclick="window.toggleEditGenderPref(this, 'man')"
          style="
            flex: 1;
            min-width: 80px;
            padding: 10px 12px;
            border: 2px solid ${hasMan ? '#3b82f6' : '#d1d5db'};
            border-radius: 10px;
            background: ${hasMan ? '#dbeafe' : '#f3f4f6'};
            color: ${hasMan ? '#1d4ed8' : '#6b7280'};
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
          "
        >
          <span>👨</span> Man
        </button>
        <button
          type="button"
          id="edit-gender-woman"
          data-gender="woman"
          data-selected="${hasWoman}"
          onclick="window.toggleEditGenderPref(this, 'woman')"
          style="
            flex: 1;
            min-width: 80px;
            padding: 10px 12px;
            border: 2px solid ${hasWoman ? '#ec4899' : '#d1d5db'};
            border-radius: 10px;
            background: ${hasWoman ? '#fce7f3' : '#f3f4f6'};
            color: ${hasWoman ? '#be185d' : '#6b7280'};
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
          "
        >
          <span>👩</span> Woman
        </button>
        <button
          type="button"
          id="edit-gender-different"
          data-gender="different"
          data-selected="${hasDifferent}"
          onclick="window.toggleEditGenderPref(this, 'different')"
          style="
            flex: 1;
            min-width: 80px;
            padding: 10px 12px;
            border: 2px solid ${hasDifferent ? '#a855f7' : '#d1d5db'};
            border-radius: 10px;
            background: ${hasDifferent ? '#f3e8ff' : '#f3f4f6'};
            color: ${hasDifferent ? '#7c3aed' : '#6b7280'};
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
          "
        >
          <span>🌈</span> Different
        </button>
      </div>
      <p style="font-size: 11px; color: #9ca3af; margin-top: 6px;">Select who can see and join this event</p>
    </div>
  `;
  
requireApprovalSection.insertAdjacentHTML('afterend', genderPrefHtml);
}

// Add category edit section (below gender preference)
const genderPrefSection = document.getElementById('edit-gender-preference-section');
const insertAfterEl = genderPrefSection || document.getElementById('edit-require-approval-section');
if (insertAfterEl && !document.getElementById('edit-category-section')) {
  const currentCategories = panel.dataset.category ? JSON.parse(panel.dataset.category) : ['entertainment'];
  window.currentEventCategories = [...currentCategories];
  
  const categoryEditHtml = '<div id="edit-category-section" style="margin-top: 16px;">' +
    '<label style="display: block; font-size: 12px; font-weight: 600; color: #5f6368; margin-bottom: 4px; text-transform: uppercase;">Category</label>' +
    '<p id="editCategoryPickerCount" style="font-size: 11px; color: #5f6368; margin: 0 0 8px 0;">' + currentCategories.length + '/3 selected</p>' +
    '<div id="editCategoryPickerButtons" style="display: flex; gap: 6px; flex-wrap: wrap;"></div>' +
  '</div>';
  
  insertAfterEl.insertAdjacentHTML('afterend', categoryEditHtml);
  
  // Populate buttons
  var editCatContainer = document.getElementById('editCategoryPickerButtons');
  if (editCatContainer) {
var cats = window.EVENT_CATEGORIES || [
      { key: 'food_drink', icon: '🍽️', label: 'Food & Drink' },
      { key: 'nightlife', icon: '🌙', label: 'Nightlife' },
      { key: 'outdoors', icon: '🌿', label: 'Outdoors' },
      { key: 'active', icon: '⚡', label: 'Active' },
      { key: 'shopping', icon: '🛍️', label: 'Shopping' },
      { key: 'entertainment', icon: '🎭', label: 'Entertainment' },
    ];
    editCatContainer.innerHTML = cats.map(function(cat) {
      var isSel = window.currentEventCategories.includes(cat.key);
      return '<button type="button" data-category="' + cat.key + '" style="padding: 5px 10px; border: 2px solid ' + (isSel ? '#2c2c2c' : '#d1d5db') + '; border-radius: 20px; background: ' + (isSel ? '#f0f0f0' : 'white') + '; font-size: 11px; font-weight: ' + (isSel ? '600' : '400') + '; cursor: pointer; transition: all 0.2s; display: flex; align-items: center; gap: 3px; white-space: nowrap;"><span>' + cat.icon + '</span><span>' + cat.label + '</span></button>';
    }).join('');
    editCatContainer.querySelectorAll('button[data-category]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        window.selectEventCategory(this.dataset.category);
      });
    });
  }
}

// Add age limit edit section (below category)
const catSectionEl = document.getElementById('edit-category-section');
const ageLimitInsertAfter = catSectionEl || document.getElementById('edit-gender-preference-section') || document.getElementById('edit-require-approval-section');
if (ageLimitInsertAfter && !document.getElementById('edit-age-limit-section')) {
  const currentAgeMin = parseInt(panel.dataset.ageMin) || 18;
  const currentAgeMax = parseInt(panel.dataset.ageMax) || 99;
  window.currentAgeMin = currentAgeMin;
  window.currentAgeMax = currentAgeMax;
  
  const leftPct = ((currentAgeMin - 18) / 81) * 100;
  const rightPct = ((99 - currentAgeMax) / 81) * 100;
  const labelText = (currentAgeMin === 18 && currentAgeMax === 99) ? '18 - 99 (all ages)' : currentAgeMin + ' - ' + currentAgeMax;
  
  const ageLimitHtml = '<div id="edit-age-limit-section" style="margin-top: 16px;">' +
    '<label style="display: block; font-size: 12px; font-weight: 600; color: #5f6368; margin-bottom: 4px; text-transform: uppercase;">Age Limit</label>' +
    '<p id="editAgeLimitLabel" style="font-size: 11px; color: #5f6368; margin: 0 0 12px 0;">' + labelText + '</p>' +
    '<div style="position: relative; height: 40px; padding: 0 8px;">' +
      '<div style="position: absolute; top: 50%; left: 8px; right: 8px; height: 4px; background: #e0e0e0; border-radius: 2px; transform: translateY(-50%);">' +
        '<div id="editAgeLimitTrack" style="position: absolute; height: 100%; background: #2c2c2c; border-radius: 2px; left: ' + leftPct + '%; right: ' + rightPct + '%;"></div>' +
      '</div>' +
      '<input type="range" id="editAgeLimitMin" min="18" max="99" value="' + currentAgeMin + '" oninput="window.updateEditAgeLimitSlider()" style="position: absolute; top: 50%; left: 8px; right: 8px; width: calc(100% - 16px); transform: translateY(-50%); -webkit-appearance: none; appearance: none; background: transparent; pointer-events: none; z-index: 3; margin: 0; height: 20px;" />' +
      '<input type="range" id="editAgeLimitMax" min="18" max="99" value="' + currentAgeMax + '" oninput="window.updateEditAgeLimitSlider()" style="position: absolute; top: 50%; left: 8px; right: 8px; width: calc(100% - 16px); transform: translateY(-50%); -webkit-appearance: none; appearance: none; background: transparent; pointer-events: none; z-index: 4; margin: 0; height: 20px;" />' +
    '</div>' +
  '</div>';
  
  ageLimitInsertAfter.insertAdjacentHTML('afterend', ageLimitHtml);
}

// Hide participants list button in edit mode
const participantsListBtn = panel.querySelector('[data-participants-list-btn]');
if (participantsListBtn) {
  participantsListBtn.style.display = 'none';
}
};

export const cancelEditMode = () => {
  const panel = document.getElementById('eventDetailsPanel');
  if (!panel) return;
  
  // Reset image edit state
  window._editImageState = 'original';
  window._editNewImageBase64 = null;
  window._editOriginalPhotoUrl = null;

  const eventId = panel.dataset.eventId;
  
  // PRESERVE the openedFromList flag FROM PANEL DATASET
  const wasOpenedFromList = panel.dataset.openedFromList === 'true';
  
  // Remove description edit icon
  const descEditIcon = panel.querySelector('[data-desc-edit-icon]');
  if (descEditIcon) {
    descEditIcon.remove();
  }

  // Hide the edit people limit icon
const editPeopleLimitIcon = document.getElementById(`editPeopleLimitIcon_${eventId}`);
if (editPeopleLimitIcon) {
  editPeopleLimitIcon.style.display = 'none';
}

// Show participants list button again
const participantsListBtn = panel.querySelector('[data-participants-list-btn]');
if (participantsListBtn) {
  participantsListBtn.style.display = 'flex';
}
  
  // Simply reload the event details panel to restore everything
  window.closeAllPanels();
  
  setTimeout(async () => {
    const { success, events } = await getAllEvents();
    
    if (success) {
      const event = events.find(e => e.eventId === eventId);
      if (event) {
        // RESTORE the flag before showing panel
        window.openedFromList = wasOpenedFromList;
        window.showEventDetailsPanel(event, event.placePhotoUrl);
      }
    }
  }, 100);
};

export const saveEventChanges = async (eventId) => {
  const panel = document.getElementById('eventDetailsPanel');
  if (!panel) return;

// Check if gender preference has at least one selection
  const genderSection = document.getElementById('edit-gender-preference-section');
  if (genderSection) {
    const selectedGenders = ['man', 'woman', 'different'].filter(g => {
      const btn = document.getElementById(`edit-gender-${g}`);
      return btn && btn.dataset.selected === 'true';
    });
    
    if (selectedGenders.length === 0) {
      window.showToast('Please select at least one gender for "Open for"', 'error');
      return;
    }
  }

// Check if there are actually any changes
  if (!window.checkForChanges()) {
    // Just exit edit mode without saving
    window.cancelEditMode();
    return;
  }

  // Edge case: user was editing start date/time but event started in the meantime
  const startEditInput = document.getElementById('edit-start-date');
  if (startEditInput) {
    const originalStart = window.originalEventData?.startDateTime || panel.dataset.startDateTime;
    if (originalStart && new Date() >= new Date(originalStart)) {
      window.showToast('This event has already started. Please close and reopen the panel to see the current state.', 'error');
      window.cancelEditMode();
      return;
    }
  }
  
  // Get edited values (only if they exist)
  const titleInput = document.getElementById('edit-title');
  const descInput = document.getElementById('edit-description');
const startDateInput = document.getElementById('edit-start-date');
const startTimeInput = document.getElementById('edit-start-time');
const endDateInput = document.getElementById('edit-end-date');
const endTimeInput = document.getElementById('edit-end-time');

// Combine date and time for validation
const startInput = (startDateInput && startTimeInput && startDateInput.value && startTimeInput.value) 
  ? { value: `${startDateInput.value}T${startTimeInput.value}` }
  : null;
  
const endInput = (endDateInput && endTimeInput && endDateInput.value && endTimeInput.value)
  ? { value: `${endDateInput.value}T${endTimeInput.value}` }
  : null;
  const labelInput = document.getElementById('edit-label');
const imageFile = document.getElementById('edit-place-image')?.files[0];
  
  // Get ORIGINAL values from panel dataset
  const originalTitle = panel.dataset.originalTitle || panel.querySelector('[data-event-title]')?.textContent.trim();
  const originalDescription = panel.dataset.originalDescription;
  const originalStartDateTime = panel.dataset.startDateTime;
  const originalEndDateTime = panel.dataset.endDateTime;
  const originalLabel = panel.dataset.customLabel;
  
  // Build update object with NEW values OR original values
const updateData = {
    title: titleInput ? titleInput.value.trim() : originalTitle,
    description: descInput ? descInput.value.trim() : originalDescription,
    endDateTime: endInput ? endInput.value : originalEndDateTime,
  };

  // Apply image state
  if (window._editImageState === 'removed') {
    updateData.placePhotoUrl = '';
  } else if (window._editImageState === 'replaced' && window._editNewImageBase64) {
    updateData.placePhotoUrl = window._editNewImageBase64;
  }

    // Add people limit if it was edited
  if (panel.dataset.tempPeopleLimit !== undefined) {
    updateData.peopleLimit = panel.dataset.tempPeopleLimit === 'null' ? null : parseInt(panel.dataset.tempPeopleLimit);
  }

// Add require approval if checkbox exists
  const requireApproveCheckbox = document.getElementById('edit-require-approve');
  if (requireApproveCheckbox) {
    updateData.requireApprove = requireApproveCheckbox.checked;
  }
  
// Add gender preference if it was edited - read directly from DOM
  const genderPrefSection = document.getElementById('edit-gender-preference-section');
  if (genderPrefSection) {
    const selectedGenders = [];
    ['man', 'woman', 'different'].forEach(g => {
      const btn = document.getElementById(`edit-gender-${g}`);
      if (btn && btn.dataset.selected === 'true') {
        selectedGenders.push(g);
      }
    });
    if (selectedGenders.length > 0) {
      updateData.genderPreference = selectedGenders;
    }
  }
  
  // Add category if it was edited
  const categorySectionEl = document.getElementById('edit-category-section');
  if (categorySectionEl && window.currentEventCategories && window.currentEventCategories.length > 0) {
    const originalCats = window.originalEventData?.category || ['entertainment'];
    const currentCats = window.currentEventCategories;
    const sameCatLen = currentCats.length === originalCats.length;
    const sameCatContent = currentCats.every(c => originalCats.includes(c));
    if (!sameCatLen || !sameCatContent) {
      updateData.category = currentCats;
    }
  }

  // Add age limit if changed
  const ageLimitSectionEl = document.getElementById('edit-age-limit-section');
  if (ageLimitSectionEl) {
    const origMin = window.originalEventData?.ageMin || 18;
    const origMax = window.originalEventData?.ageMax || 99;
    if (window.currentAgeMin !== origMin || window.currentAgeMax !== origMax) {
      updateData.ageMin = window.currentAgeMin;
      updateData.ageMax = window.currentAgeMax;
    }
  }
  
  // Validation - only validate fields that were actually edited
  if (titleInput && !updateData.title) {
    window.showToast('Title cannot be empty', 'error');
    return;
  }
  
  if (descInput && !updateData.description) {
    window.showToast('Description cannot be empty', 'error');
    return;
  }
  
  if (endInput && !updateData.endDateTime) {
    window.showToast('End date/time is required', 'error');
    return;
  }
  
// Add start date if it was edited
if (startInput) {
  updateData.startDateTime = startInput.value;
  
  // Validate: start date cannot be in the past
  const now = new Date();
  const newStartDate = new Date(startInput.value);
  
  if (newStartDate < now) {
    window.showToast('Start date/time cannot be in the past', 'error');
    return;
  }
  
  // Only validate dates if BOTH were edited
  if (startInput.value && endInput && endInput.value) {
    const startDate = new Date(startInput.value);
    const endDate = new Date(endInput.value);
    
    if (endDate <= startDate) {
      window.showToast('End date/time must be after start date/time', 'error');
      return;
    }
    
    // Check duration (max 7 days)
    const diffInMs = endDate - startDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    
    if (diffInDays > 7) {
      window.showToast('Event duration cannot exceed 7 days', 'error');
      return;
    }
  }
}

// Validate end date against current time (for started events) or start time (for upcoming events)
if (endInput && endInput.value) {
  const hasStarted = panel.dataset.hasStarted === 'true';
  const endDate = new Date(endInput.value);
  
  if (hasStarted) {
    // Event has started - end must be after CURRENT time
    const now = new Date();
    
    if (endDate <= now) {
      window.showToast('End date/time must be after current date/time', 'error');
      return;
    }
  } else if (!startInput) {
    // Event hasn't started and start wasn't edited - check against original start
    const startDate = new Date(originalStartDateTime);
    
    if (endDate <= startDate) {
      window.showToast('End date/time must be after start date/time', 'error');
      return;
    }
  }
  
  // Check duration (max 7 days from start)
  const eventStartDate = startInput ? new Date(startInput.value) : new Date(originalStartDateTime);
  const diffInMs = endDate - eventStartDate;
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  
  if (diffInDays > 7) {
    window.showToast('Event duration cannot exceed 7 days from the start date', 'error');
    return;
  }
  
  // Check if on same day - validate times
  if (eventStartDate.toDateString() === endDate.toDateString()) {
    if (endDate <= eventStartDate) {
      window.showToast('End time must be after start time on the same day', 'error');
      return;
    }
  }
}
  
  // Update label only if the user actually opened and edited it
  if (labelInput) {
    const labelWrapper = document.getElementById('label-input-wrapper');
    const isEditing = labelWrapper && labelWrapper.style.display !== 'none';
    if (isEditing) {
      if (!labelInput.value.trim()) {
        window.showToast('Label is required for custom locations', 'error');
        return;
      }
      // Label is stored as place_name in the DB (no custom_label column)
      updateData.placeName = labelInput.value.trim();
    }
    // If not editing — don't touch place_name at all
  }
  
  // Show loading state
  const actionButtons = document.getElementById('actionButtons');
  if (actionButtons) {
actionButtons.innerHTML = `
      <div style="text-align: center; padding: 14px;">
        ${window.CustomLoadingSpinner({ size: 36, message: 'Saving changes...' })}
      </div>
    `;
  }
  // Skip realtime subscription from also refreshing this event's marker
  window.skipRealtimeUpdate = eventId;
  
  // Update in database
  const { success, error } = await updateEvent(eventId, updateData);
  
if (success) {
// Remove participants who no longer qualify due to gender/age changes
  const genderPrefSection = document.getElementById('edit-gender-preference-section');
  const genderJustChanged = genderPrefSection && updateData.genderPreference;
  const ageJustChanged = updateData.ageMin !== undefined || updateData.ageMax !== undefined;

  if (genderJustChanged || ageJustChanged) {
    const supabaseClient = window.supabase || supabase;

    const { data: freshEvent } = await supabaseClient
      .from('events')
      .select('participants, creator_id, title, gender_preference, age_min, age_max')
      .eq('event_id', eventId)
      .single();

    if (freshEvent) {
      const newGender = freshEvent.gender_preference || ['man', 'woman', 'different'];
      const newAgeMin = freshEvent.age_min || 18;
      const newAgeMax = freshEvent.age_max || 99;
      const otherParticipants = (freshEvent.participants || []).filter(id => id !== freshEvent.creator_id);

      const toRemove = [];
      for (const userId of otherParticipants) {
        const { data: userData } = await supabaseClient
          .from('users')
          .select('id, gender, date_of_birth')
          .eq('id', userId)
          .single();
        if (!userData) continue;
        let qualifies = true;
        if (genderJustChanged && userData.gender && !newGender.includes(userData.gender)) qualifies = false;
        if (ageJustChanged && userData.date_of_birth) {
          const age = Math.floor((Date.now() - new Date(userData.date_of_birth)) / (365.25 * 24 * 60 * 60 * 1000));
          if (age < newAgeMin || age > newAgeMax) qualifies = false;
        }
        if (!qualifies) toRemove.push(userId);
      }

      if (toRemove.length > 0) {
        // Single DB update — no second realtime event fired separately
        const updatedParticipants = (freshEvent.participants || []).filter(id => !toRemove.includes(id));
window.skipRealtimeUpdate = eventId;
        await supabaseClient
          .from('events')
          .update({ participants: updatedParticipants })
          .eq('event_id', eventId);
        setTimeout(() => { window.skipRealtimeUpdate = null; }, 2000);

        // Notifications for removed users
        const notifInserts = toRemove.map(userId => ({
          user_id: userId,
          type: 'removed_from_event',
          title: 'Removed from Event',
          message: `You were removed from "${freshEvent.title}" due to updated event requirements`,
          event_id: eventId,
          event_title: freshEvent.title,
        }));
        await supabaseClient.from('notifications').insert(notifInserts);
      }
    }
  }

  // Update window.allEvents immediately so marker popups show correct data
  if (window.allEvents) {
    const eventIndex = window.allEvents.findIndex(e => e.eventId === eventId);
    if (eventIndex !== -1) {
      // Merge updateData into the existing event
      window.allEvents[eventIndex] = {
        ...window.allEvents[eventIndex],
        title: updateData.title || window.allEvents[eventIndex].title,
        description: updateData.description || window.allEvents[eventIndex].description,
        startDateTime: updateData.startDateTime || window.allEvents[eventIndex].startDateTime,
        endDateTime: updateData.endDateTime || window.allEvents[eventIndex].endDateTime,
        peopleLimit: updateData.peopleLimit !== undefined ? updateData.peopleLimit : window.allEvents[eventIndex].peopleLimit,
        requireApprove: updateData.requireApprove !== undefined ? updateData.requireApprove : window.allEvents[eventIndex].requireApprove,
        genderPreference: updateData.genderPreference || window.allEvents[eventIndex].genderPreference,
        category: updateData.category || window.allEvents[eventIndex].category,
        ageMin: updateData.ageMin !== undefined ? updateData.ageMin : window.allEvents[eventIndex].ageMin,
        ageMax: updateData.ageMax !== undefined ? updateData.ageMax : window.allEvents[eventIndex].ageMax
      };
    }
  }
  
// Check if dates were changed - if so, reload panel to recalculate everything
  const datesChanged = startInput || endInput;
  const requireApproveChanged = requireApproveCheckbox && (requireApproveCheckbox.checked !== (panel.dataset.requireApprove === 'true'));
  
// Check if gender preference was changed
  const genderChanged = genderPrefSection && updateData.genderPreference;
  
  const categoryChanged = !!updateData.category;
  const ageLimitChanged = updateData.ageMin !== undefined || updateData.ageMax !== undefined;
  
if (datesChanged || descInput || requireApproveChanged || genderChanged || categoryChanged || ageLimitChanged) {
  // Dates or description changed - reload panel to recalculate status, countdown, colors
  
  // PRESERVE the openedFromList flag FROM PANEL DATASET
  const wasOpenedFromList = panel.dataset.openedFromList === 'true';
  window.closeAllPanels();
  
  setTimeout(async () => {
    const { success: fetchSuccess, events } = await getAllEvents();
    
    if (fetchSuccess) {
      const event = events.find(e => e.eventId === eventId);
      if (event) {
        window.openedFromList = wasOpenedFromList;
        window.showEventDetailsPanel(event, event.placePhotoUrl);
      }
    }
  }, 100);
    
// Refresh just this event's marker immediately
  if (window.refreshSingleEventMarker) {
    await window.refreshSingleEventMarker(eventId);
  }
  
// Re-enable realtime updates
  setTimeout(() => { window.skipRealtimeUpdate = null; }, 1000);

  // Reset image edit state
  window._editImageState = 'original';
  window._editNewImageBase64 = null;
  window._editOriginalPhotoUrl = null;
  
  if (window.loadUserEvents) {
    window.loadUserEvents();
  }
    
  return;
}
  
  // For title-only changes, just update in place
  if (titleInput) {
    const titleElement = panel.querySelector('[data-event-title]');
    if (titleElement) {
      titleElement.textContent = updateData.title;
      titleElement.innerHTML = updateData.title;
    }
    
    // Update dataset
    panel.dataset.originalTitle = updateData.title;
  }
  
  // Exit edit mode - restore action buttons
  const currentPanel = document.getElementById('eventDetailsPanel');
  const hasEnded = new Date() >= new Date(updateData.endDateTime || originalEndDateTime);
  const hasStarted = new Date() >= new Date(updateData.startDateTime || originalStartDateTime);
  
  
const currentActionButtons = document.getElementById('actionButtons');
if (currentActionButtons) {
  currentActionButtons.style.cssText = `
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 24px;
    background: white;
    border-top: 1px solid #e5e7eb;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  `;
  
  currentActionButtons.innerHTML = `
    <div style="
      display: flex;
      gap: 12px;
      justify-content: center;
    ">
      ${!hasEnded ? `
      <!-- Edit Button -->
      <button
        onclick="enableEditMode('${eventId}')"
        style="
          width: 140px;
          padding: 12px 20px;
          background: #f8f9fa;
          color: rgba(131, 131, 131, 1);
          border: 2px solid rgba(131, 131, 131, 1);
          border-radius: 30px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          box-shadow: rgba(0, 0, 0, 0.4) 2px 2px 6px;
        "
        onmouseover="this.style.background='#ddddddff';"
        onmouseout="this.style.background='#f8f9fa';"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
        Edit
      </button>
      ` : ''}
      
      <!-- Delete Button -->
      <button
        onclick="deleteEventConfirm('${eventId}')"
        style="
          width: 140px;
          padding: 12px 20px;
          background: #fef7f7;
          color: rgba(255, 23, 0, 1);
          border: 2px solid rgba(255, 23, 0, 1);
          border-radius: 30px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          box-shadow: rgba(0, 0, 0, 0.4) 2px 2px 6px;
        "
        onmouseover="this.style.background='#fa050533';"
        onmouseout="this.style.background='#fef7f7';"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        </svg>
        Delete
      </button>
    </div>
  `;
}

// Show participants list button again
const participantsListBtn = panel.querySelector('[data-participants-list-btn]');
if (participantsListBtn) {
  participantsListBtn.style.display = 'flex';
}

// Remove description edit icon when exiting edit mode
const descEditIcon = panel.querySelector('[data-desc-edit-icon]');
if (descEditIcon) {
  descEditIcon.remove();
}

// Hide the edit people limit icon
const editPeopleLimitIcon = document.getElementById(`editPeopleLimitIcon_${eventId}`);
if (editPeopleLimitIcon) {
  editPeopleLimitIcon.style.display = 'none';
}

// Debug: Check back button
const backButton = panel.querySelector('button[onclick*="showEventsListPanel"]');
  
// Small delay to ensure UI updates, then update marker inline
  setTimeout(async () => {
    // Get fresh event data
    const supabaseClient = window.supabase || supabase;
    const { data: markerData } = await supabaseClient
      .from('events')
      .select('place_id, participants, people_limit')
      .eq('event_id', eventId)
      .single();
    
    if (markerData) {
      const placeId = markerData.place_id;
      if (placeId && window.eventMarkersRef.current) {
        const marker = window.eventMarkersRef.current.find(m => {
          const content = m.content || m.getElement?.() || m._element;
          if (!content) return false;
          const directPlaceId = content.dataset?.placeId;
          const childPlaceId = content.querySelector?.('[data-place-id]')?.dataset?.placeId;
          const markerPlaceId = directPlaceId || childPlaceId;
          return markerPlaceId === placeId;
        });
        
        if (marker) {
          const markerElement = marker.content || marker.getElement?.() || marker._element;
          if (markerElement) {
            const participantCountSpans = markerElement.querySelectorAll('span[style*="font-weight: 600"]');
            participantCountSpans.forEach(countSpan => {
              if (countSpan.textContent.includes('/')) {
                const newCount = markerData.participants.length;
                const limit = markerData.people_limit;
                countSpan.textContent = limit ? `${newCount} / ${limit}` : `${newCount} / ∞`;
              }
            });
          }
        }
      }
    }
    
// Reload user events in profile panel
    if (window.loadUserEvents) {
      window.loadUserEvents();
    }
    
// Refresh just this event's marker
    if (window.refreshSingleEventMarker) {
      await window.refreshSingleEventMarker(eventId);
    }
    
    // Re-enable realtime updates
    setTimeout(() => { window.skipRealtimeUpdate = null; }, 1000);
  }, 300);
} else {
    window.showToast('Failed to update event. Please try again.', 'error');
    window.skipRealtimeUpdate = null;
    
    // Restore buttons
    window.cancelEditMode();
  }
};

export const deleteEventConfirm = (eventId) => {
  window.dispatchEvent(new CustomEvent('openConfirmModal', {
    detail: {
      icon: '🗑️',
      iconBg: '#fef7f7',
      title: 'Delete Event',
      message: 'Are you sure you want to delete this event? This action cannot be undone and all participants will be removed.',
      confirmText: 'Delete Event',
      cancelText: 'Keep Event',
      confirmColor: '#ea4335',
      confirmHoverColor: '#d33426',
      onConfirm: async () => {
        if (window.performDeleteEvent) await window.performDeleteEvent(eventId);
      }
    }
  }));
};

// Helper function to update start time options based on selected date
export const updateEditStartTimeOptions = () => {
  const startDateInput = document.getElementById('edit-start-date');
  const startTimeSelect = document.getElementById('edit-start-time');
  
  if (!startDateInput || !startTimeSelect) return;
  
  const selectedDate = startDateInput.value;
  if (!selectedDate) return;
  
  const now = new Date();
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  
  // If selected date is today, disable past times
  if (selectedDate === todayStr) {
    const currentHour = now.getHours();
    const currentMinute = Math.ceil(now.getMinutes() / 5) * 5;
    const currentTimeValue = currentHour * 60 + currentMinute;
    
    Array.from(startTimeSelect.options).forEach(option => {
      if (option.value === '') return; // Skip the placeholder
      
      const [hours, minutes] = option.value.split(':').map(Number);
      const optionTimeValue = hours * 60 + minutes;
      
      option.disabled = optionTimeValue < currentTimeValue;
    });
    
    // If current selection is now disabled, clear it
    if (startTimeSelect.value) {
      const [hours, minutes] = startTimeSelect.value.split(':').map(Number);
      const selectedTimeValue = hours * 60 + minutes;
      if (selectedTimeValue < currentTimeValue) {
        startTimeSelect.value = '';
      }
    }
  } else {
    // Enable all options for future dates
    Array.from(startTimeSelect.options).forEach(option => {
      option.disabled = false;
    });
  }
};

// Helper function to update end date min when start date changes
export const updateEditEndDateMin = () => {
  const panel = document.getElementById('eventDetailsPanel');
  if (!panel) return;
  
  const startDateInput = document.getElementById('edit-start-date');
  const endDateInput = document.getElementById('edit-end-date');
  
  if (startDateInput && startDateInput.value) {
    const startDate = new Date(startDateInput.value);
    const minDateStr = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;
    
    // Max date is 7 days from start
    const maxDate = new Date(startDate);
    maxDate.setDate(maxDate.getDate() + 7);
    const maxDateStr = `${maxDate.getFullYear()}-${String(maxDate.getMonth() + 1).padStart(2, '0')}-${String(maxDate.getDate()).padStart(2, '0')}`;
    
    if (endDateInput) {
      endDateInput.min = minDateStr;
      endDateInput.max = maxDateStr;
      
      // If current end date is before new start date, clear it
      if (endDateInput.value && endDateInput.value < minDateStr) {
        endDateInput.value = '';
        const endTimeSelect = document.getElementById('edit-end-time');
        if (endTimeSelect) endTimeSelect.value = '';
      }
    }
    
    // Update end time options
    window.updateEditEndTimeMin();
  }
};

// Helper function to filter end time options
export const updateEditEndTimeMin = () => {
  const panel = document.getElementById('eventDetailsPanel');
  if (!panel) return;
  
  const endDateInput = document.getElementById('edit-end-date');
  const endTimeSelect = document.getElementById('edit-end-time');
  
  if (!endDateInput || !endTimeSelect) return;
  
  const endDate = endDateInput.value;
  if (!endDate) return;
  
  // Check if event has started (stored in data attribute)
  const hasStarted = endDateInput.dataset.hasStarted === 'true';
  
  // Determine constraint date and time
  let constraintDate, constraintTime;
  
  if (hasStarted) {
    // For started events, constraint is CURRENT time
    const now = new Date();
    constraintDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const nowHours = String(now.getHours()).padStart(2, '0');
    const nowMinutes = String(Math.ceil(now.getMinutes() / 5) * 5).padStart(2, '0');
    constraintTime = `${nowHours}:${nowMinutes}`;
  } else {
    // For upcoming events, check if start is being edited
    const startDateInput = document.getElementById('edit-start-date');
    const startTimeSelect = document.getElementById('edit-start-time');
    
    if (startDateInput && startTimeSelect && startDateInput.value && startTimeSelect.value) {
      // Start is being edited - use edited values
      constraintDate = startDateInput.value;
      constraintTime = startTimeSelect.value;
    } else {
      // Start not being edited - use stored constraint (original start time)
      constraintDate = endDateInput.dataset.constraintDate;
      constraintTime = endDateInput.dataset.constraintTime;
    }
  }
  
  // If same day as constraint, disable times before or equal to constraint time
  if (constraintDate && constraintTime && endDate === constraintDate) {
    const [constraintHours, constraintMinutes] = constraintTime.split(':').map(Number);
    const constraintTimeValue = constraintHours * 60 + constraintMinutes;
    
    Array.from(endTimeSelect.options).forEach(option => {
      if (option.value === '') return; // Skip placeholder
      
      const [hours, minutes] = option.value.split(':').map(Number);
      const optionTimeValue = hours * 60 + minutes;
      
      option.disabled = optionTimeValue <= constraintTimeValue;
    });
    
    // Clear selection if now invalid
    if (endTimeSelect.value) {
      const [hours, minutes] = endTimeSelect.value.split(':').map(Number);
      const selectedTimeValue = hours * 60 + minutes;
      if (selectedTimeValue <= constraintTimeValue) {
        endTimeSelect.value = '';
      }
    }
  } else {
    // Different dates - enable all options
    Array.from(endTimeSelect.options).forEach(option => {
      option.disabled = false;
    });
  }
};

// Toggle gender preference in edit mode
export const toggleEditGenderPref = (btn, gender) => {
  const currentlySelected = btn.dataset.selected === 'true';
  btn.dataset.selected = (!currentlySelected).toString();
  
  const colors = {
    man: { selected: { bg: '#dbeafe', border: '#3b82f6', text: '#1d4ed8' }, unselected: { bg: '#f3f4f6', border: '#d1d5db', text: '#6b7280' } },
    woman: { selected: { bg: '#fce7f3', border: '#ec4899', text: '#be185d' }, unselected: { bg: '#f3f4f6', border: '#d1d5db', text: '#6b7280' } },
    different: { selected: { bg: '#f3e8ff', border: '#a855f7', text: '#7c3aed' }, unselected: { bg: '#f3f4f6', border: '#d1d5db', text: '#6b7280' } }
  };
  
  const state = !currentlySelected ? 'selected' : 'unselected';
  const style = colors[gender][state];
  
  btn.style.background = style.bg;
  btn.style.borderColor = style.border;
  btn.style.color = style.text;
  
  // Update global preference array
  const selected = [];
  ['man', 'woman', 'different'].forEach(g => {
    const gBtn = document.getElementById(`edit-gender-${g}`);
    if (gBtn && gBtn.dataset.selected === 'true') {
      selected.push(g);
    }
  });
  
  window.currentEventGenderPreference = selected;
  
  // Trigger save button state update
  if (window.updateSaveButtonState) {
    window.updateSaveButtonState();
  }
};

// Helper function to validate end date/time
export const validateEditEndDateTime = () => {
  const panel = document.getElementById('eventDetailsPanel');
  if (!panel) return true;
  
  const startDateInput = document.getElementById('edit-start-date');
  const startTimeSelect = document.getElementById('edit-start-time');
  const endDateInput = document.getElementById('edit-end-date');
  const endTimeSelect = document.getElementById('edit-end-time');
  
  if (!endDateInput || !endTimeSelect || !endDateInput.value || !endTimeSelect.value) return true;
  
  // Get start date/time (either from inputs or original)
  let startDateTime;
  if (startDateInput && startTimeSelect && startDateInput.value && startTimeSelect.value) {
    startDateTime = `${startDateInput.value}T${startTimeSelect.value}`;
  } else {
    startDateTime = panel.dataset.startDateTime;
  }
  
  const endDateTime = `${endDateInput.value}T${endTimeSelect.value}`;
  
  const startDate = new Date(startDateTime);
  const endDate = new Date(endDateTime);
  
  // Check if end is after start
  if (endDate <= startDate) {
    window.showToast('End date/time must be after start date/time', 'error');
    endTimeSelect.value = '';
    return false;
  }
  
  // Check duration (max 7 days)
  const diffInMs = endDate - startDate;
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  
  if (diffInDays > 7) {
    window.showToast('Event duration cannot exceed 7 days', 'error');
    endDateInput.value = '';
    endTimeSelect.value = '';
    return false;
  }
  
  return true;
};

export const showEditPeopleLimitModal = (eventId, currentParticipants, currentLimit) => {
  window.dispatchEvent(new CustomEvent('openEditPeopleLimitModal', {
    detail: { eventId, currentParticipants, currentLimit }
  }));
};

// Actually delete the event
export const performDeleteEvent = async (eventId) => {
  // Remove modal
  document.getElementById('deleteConfirmModal')?.remove();

    // SET A FLAG to prevent real-time subscription from interfering
  if (!window.deletingOwnEvents) {
    window.deletingOwnEvents = new Set();
  }
  window.deletingOwnEvents.add(eventId);
  
  // Show loading state
  const loadingModal = document.createElement('div');
  loadingModal.id = 'deleteLoadingModal';
  loadingModal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10002;
  `;
loadingModal.innerHTML = `
  <div style="background: white; padding: 32px; border-radius: 12px; text-align: center;">
    ${window.CustomLoadingSpinner({ size: 56, message: 'Deleting event...' })}
  </div>
`;
  document.body.appendChild(loadingModal);
  
  try {
    const supabaseClient = window.supabase || supabase;
    const currentUserId = window.currentAppUser?.uid || window.currentUser?.uid;
    
    // STEP 1: Get event details BEFORE deleting (to notify participants and get placeId)
    const { data: eventData, error: fetchError } = await supabaseClient
      .from('events')
      .select('event_id, title, participants, creator_id, place_id, place_name, place_address, latitude, longitude')
      .eq('event_id', eventId)
      .single();
    
    if (fetchError) throw fetchError;
    
    const placeId = eventData.place_id;
    
    // STEP 2: Get affected participants (exclude the creator)
    const affectedParticipants = (eventData.participants || []).filter(
      participantId => participantId !== currentUserId
    );
    
    // STEP 3: Check how many events are at this location BEFORE deleting
    const { data: eventsAtPlace, error: eventsError } = await supabaseClient
      .from('events')
      .select('event_id')
      .eq('place_id', placeId);
    
    const remainingEventCount = (eventsAtPlace || []).filter(e => e.event_id !== eventId).length;
    // STEP 4: IMMEDIATELY remove or update the marker BEFORE deleting from database
    if (window.eventMarkersRef && window.eventMarkersRef.current) {
      const markerIndex = window.eventMarkersRef.current.findIndex(marker => {
        if (!marker) return false;
        const markerElement = marker.getElement?.() || marker._element;
        if (!markerElement) return false;
        
        const markerPlaceId = markerElement.querySelector?.('[data-place-id]')?.dataset?.placeId;
        return markerPlaceId === placeId;
      });
      
if (markerIndex !== -1) {
        const marker = window.eventMarkersRef.current[markerIndex];
        
        // Remove from cluster group first (always — either we're removing entirely or refreshing)
        if (window.markerClusterGroup) {
          window.markerClusterGroup.removeLayer(marker);
        }
        
        if (marker.remove) marker.remove();
        window.eventMarkersRef.current.splice(markerIndex, 1);
        
        // Also clean any orphaned DOM elements for this placeId
        document.querySelectorAll(`[data-place-id="${placeId}"]`).forEach(el => {
          const wrapper = el.closest('.leaflet-marker-icon, .leaflet-interactive');
          if (wrapper) wrapper.remove();
          else el.remove();
        });
      }
    }
    
    // Remove deleted event from window.allEvents
    if (window.allEvents) {
      window.allEvents = window.allEvents.filter(e => e.eventId !== eventId);
    }
    
    // STEP 5: Delete the event from database
    const { success } = await deleteEvent(eventId);
    
    if (!success) throw new Error('Failed to delete event');
    
    // STEP 6: If there were other events, refresh the marker now
    if (remainingEventCount > 0 && window.refreshSingleEventMarker) {
      // Pass the placeId as a second parameter so it doesn't try to fetch the deleted event
      const { data: remainingEvents } = await supabaseClient
        .from('events')
        .select('*')
        .eq('place_id', placeId);
      
      if (remainingEvents && remainingEvents.length > 0) {
        // Get the first event to use as reference
        const refEvent = remainingEvents[0];
        await window.refreshSingleEventMarker(refEvent.event_id);
      }
    }
    
    // STEP 7: Send notifications to affected participants
    if (affectedParticipants.length > 0) {
      const notifications = affectedParticipants.map(participantId => ({
        user_id: participantId,
        type: 'event_deleted',
        title: 'Event Removed',
        message: `The event "${eventData.title}" has been cancelled`,
        event_id: eventData.event_id,
        event_title: eventData.title,
        is_read: false
      }));
      
      const {} = await supabaseClient
        .from('notifications')
        .insert(notifications);
    }
    
    // Remove loading modal
    loadingModal.remove();
    
    window.showToast(`Event deleted successfully`, 'success');
    
    // Close event details panel
    const panel = document.getElementById('eventDetailsPanel');
    if (panel) {
      panel.style.right = '-400px';
      setTimeout(() => panel.remove(), 300);
    }
    
// Handle events list panel
    const listPanel = document.getElementById('eventsListPanel');
    if (listPanel) {
      if (remainingEventCount === 0) {
        listPanel.style.right = '-400px';
        setTimeout(() => { if (window.resetRightButtons) window.resetRightButtons(); }, 310);
        setTimeout(() => listPanel.remove(), 300);
      } else if (remainingEventCount === 1) {
        // Only 1 event left — open it directly in event details
        const remaining = window.allEvents?.filter(e => e.eventId !== eventId);
        const singleEvent = remaining?.[0];
        if (singleEvent && window.showEventDetailsPanel) {
          listPanel.style.right = '-400px';
          setTimeout(() => listPanel.remove(), 300);
          setTimeout(() => {
            window.showEventDetailsPanel(singleEvent, singleEvent.placePhotoUrl || singleEvent.placeIcon || '');
          }, 200);
        } else {
          // Fallback: show list anyway
          setTimeout(() => {
            window.showEventsListPanel(
              placeId,
              eventData.place_name,
              eventData.place_address,
              eventData.latitude,
              eventData.longitude,
            );
          }, 200);
        }
      } else {
        setTimeout(() => {
          window.showEventsListPanel(
            placeId,
            eventData.place_name,
            eventData.place_address,
            eventData.latitude,
            eventData.longitude,
          );
        }, 200);
      }
    }
    
    // Reload user events in profile panel
    if (window.loadUserEvents) {
      setTimeout(() => {
        window.loadUserEvents();
      }, 300);
    }
    
  } catch (error) {
        // CLEAR THE FLAG
    if (window.deletingOwnEvents) {
      window.deletingOwnEvents.delete(eventId);
    }

    // Remove loading modal
    loadingModal.remove();
    
    // Show error
    window.showToast('Failed to delete event. Please try again.', 'error');
  }
    // ALSO CLEAR THE FLAG after successful deletion (add this before the closing brace)
  if (window.deletingOwnEvents) {
    window.deletingOwnEvents.delete(eventId);
  }
};

window.checkForChanges = checkForChanges;
window.updateSaveButtonState = updateSaveButtonState;
window.enableEditMode = enableEditMode;
window.makeFieldsEditable = makeFieldsEditable;
window.cancelEditMode = cancelEditMode;
window.saveEventChanges = saveEventChanges;
window.deleteEventConfirm = deleteEventConfirm;
window.updateEditStartTimeOptions = updateEditStartTimeOptions;
window.updateEditEndDateMin = updateEditEndDateMin;
window.updateEditEndTimeMin = updateEditEndTimeMin;
window.toggleEditGenderPref = toggleEditGenderPref;
window.validateEditEndDateTime = validateEditEndDateTime;
window.showEditPeopleLimitModal = showEditPeopleLimitModal;
window.performDeleteEvent = performDeleteEvent;